import 'mdn-polyfills/NodeList.prototype.forEach';

export default class Avi {
  constructor(element) {
    this.element = element;
    this.button = this.element.querySelector(".js-avi-button");
    this.text = this.element.querySelector(".js-avi-text");
  }

  mount() {
    if (this.text.offsetHeight > 120) {
      this.element.classList.add("c-avi--long");
    }

    this.button.addEventListener("click", (event) => {
      if (this.element.classList.contains("c-avi--long")) {
        this.element.classList.remove("c-avi--long");
      }
    })
  }

  unmount() {
  }
}
